import React from 'react'
import { Alert, Button, Col, Row, Form, FormGroup, FormLabel, FormControl, Modal, ModalTitle } from 'react-bootstrap'
import './CareUnitProfile.css'

const CareUnitProfile = ({
        isOpen,
        errorMessage,
        updateCareUnit,
        closeDialog,
        careUnitForm,
        roles
    }) => {

    let careUnitNameInputRef = React.createRef();
    let streetAddressInputRef = React.createRef();
    let zipCodeInputRef = React.createRef();
    let cityInputRef = React.createRef();
    let contactNameInputRef = React.createRef();
    let contactPhoneInputRef = React.createRef();
    let clinicInfoInputRef = React.createRef();
    let saveButtonRef = React.createRef();

    // Check if user is admin (can edit)
    const isAdmin = roles && roles.some(role => role === 'ROLE_CARE_UNIT_ADMIN' || role === 'ROLE_ADMIN');
    const readOnly = !isAdmin;

    const performUpdate = () => {
        updateCareUnit({
            ...careUnitForm,
            name: careUnitNameInputRef.current.value,
            streetAddress: streetAddressInputRef.current.value,
            zipCode: zipCodeInputRef.current.value,
            city: cityInputRef.current.value,
            contactName: contactNameInputRef.current.value,
            contactPhoneNumber: contactPhoneInputRef.current.value,
            clinicInfo: clinicInfoInputRef.current.value
        });
    }

    const significantFieldChanged = () => {
        if (saveButtonRef.current) {
            saveButtonRef.current.disabled = !(careUnitNameInputRef.current.value && careUnitNameInputRef.current.value.length > 0)
        }
    }

    return (
        isOpen &&
        (<Modal
            show={true}
            onHide={closeDialog}
            backdrop="static"
            keyboard={true}
            size="lg"
        >
            <div className="CareUnitProfile">
                <Modal.Header closeButton>
                    <ModalTitle>
                        <h3>Min organisation</h3>
                    </ModalTitle>
                </Modal.Header>
                <Modal.Body>
                    {errorMessage &&
                    <Alert variant="danger">{errorMessage}</Alert>
                    }
                    <Form id="saveCareUnitForm" className="CareUnitProfileForm"
                          onSubmit={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              performUpdate();
                          }}>
                        <Row>
                            <Col sm={12}>

                                <FormGroup className="mb-3" controlId="formHorizontalCareUnitName">
                                    <FormLabel>Vårdenhetens namn</FormLabel>
                                    <FormControl type="text"
                                                 ref={careUnitNameInputRef}
                                                 readOnly={readOnly}
                                                 onKeyPress={(e) => {
                                                     if (e.charCode === 13) {
                                                         e.preventDefault();
                                                         e.stopPropagation();
                                                         streetAddressInputRef.current.focus();
                                                     }
                                                 }}
                                                 onChange={() => significantFieldChanged()}
                                                 defaultValue={careUnitForm.name}
                                                 placeholder="Vårdenhetens namn"
                                    />
                                </FormGroup>
                                <FormGroup className="mb-3" controlId="formHorizontalStreetAddress">
                                    <FormLabel>Gatuadress</FormLabel>
                                    <FormControl type="text"
                                                 ref={streetAddressInputRef}
                                                 readOnly={readOnly}
                                                 onKeyPress={(e) => {
                                                     if (e.charCode === 13) {
                                                         e.preventDefault();
                                                         e.stopPropagation();
                                                         zipCodeInputRef.current.focus();
                                                     }
                                                 }}
                                                 defaultValue={careUnitForm.streetAddress}
                                                 placeholder="Ex: Sjukhusvägen 15B"
                                    />
                                </FormGroup>
                                <FormGroup className="mb-3" controlId="formHorizontalZipCode">
                                    <FormLabel>Postnummer</FormLabel>
                                    <FormControl type="text"
                                                 ref={zipCodeInputRef}
                                                 readOnly={readOnly}
                                                 onKeyPress={(e) => {
                                                     if (e.charCode === 13) {
                                                         e.preventDefault();
                                                         e.stopPropagation();
                                                         cityInputRef.current.focus();
                                                     }
                                                 }}
                                                 defaultValue={careUnitForm.zipCode}
                                                 placeholder="Ex: 112 12"
                                    />
                                </FormGroup>
                                <FormGroup className="mb-3" controlId="formHorizontalCity">
                                    <FormLabel>Stad</FormLabel>
                                    <FormControl type="text"
                                                 ref={cityInputRef}
                                                 readOnly={readOnly}
                                                 onKeyPress={(e) => {
                                                     if (e.charCode === 13) {
                                                         e.preventDefault();
                                                         e.stopPropagation();
                                                         contactNameInputRef.current.focus();
                                                     }
                                                 }}
                                                 defaultValue={careUnitForm.city}
                                                 placeholder="Stad"
                                    />
                                </FormGroup>
                                <FormGroup className="mb-3" controlId="formHorizontalContactName">
                                    <FormLabel>Namn på kontaktperson</FormLabel>
                                    <FormControl type="text"
                                                 ref={contactNameInputRef}
                                                 readOnly={readOnly}
                                                 inputRef={(ref) => {
                                                     contactNameInputRef = ref
                                                 }}
                                                 onKeyPress={(e) => {
                                                     if (e.charCode === 13) {
                                                         e.preventDefault();
                                                         e.stopPropagation();
                                                         contactPhoneInputRef.current.focus();
                                                     }
                                                 }}
                                                 defaultValue={careUnitForm.contactName}
                                                 placeholder="För- och efternamn"
                                    />
                                </FormGroup>
                                <FormGroup className="mb-3" controlId="formHorizontalContactPhone">
                                    <FormLabel>Telefonnummer för kontakt</FormLabel>
                                    <FormControl type="text"
                                                 ref={contactPhoneInputRef}
                                                 readOnly={readOnly}
                                                 onKeyPress={(e) => {
                                                     if (e.charCode === 13) {
                                                         e.preventDefault();
                                                         e.stopPropagation();
                                                         clinicInfoInputRef.current.focus();
                                                     }
                                                 }}
                                                 defaultValue={careUnitForm.contactPhoneNumber}
                                                 placeholder="Telefonnummer"
                                    />
                                    <FormGroup className="mb-3" controlId="formHorizontalClinicInfo">
                                        <FormLabel>Klinikinformation</FormLabel>
                                        <FormControl type="text"
                                                     ref={clinicInfoInputRef}
                                                     readOnly={readOnly}
                                                     onKeyPress={(e) => {
                                                         if (e.charCode === 13) {
                                                             e.preventDefault();
                                                             e.stopPropagation();
                                                             performUpdate();
                                                         }
                                                     }}
                                                     defaultValue={careUnitForm.clinicInfo}
                                                     placeholder="Klinikspecifik information till optiker"
                                        />
                                    </FormGroup>
                                </FormGroup>
                            </Col>
                        </Row>

                        <FormGroup>
                            <Row style={{ display: "flex", justifyContent: "flex-end" }}>
                                <Col
                                    xs={5}
                                    style={{ display: "flex", justifyContent: "flex-end" }}
                                >
                                    <Button variant={'danger'} onClick={closeDialog} style={{marginLeft: '5px'}}>
                                        {readOnly ? 'Stäng' : 'Avbryt'}
                                    </Button>
                                    {!readOnly && (
                                        <Button variant={'primary'} style={{marginLeft: '5px'}} onClick={() => {
                                            performUpdate();
                                        }}>Spara</Button>
                                    )}
                                </Col>
                            </Row>
                        </FormGroup>
                    </Form>
                </Modal.Body>
            </div>
        </Modal>)
    )}
export default CareUnitProfile;